import React from 'react';
import {
	LineChart,
	Line,
	XAxis,
	YAxis,
	ResponsiveContainer,
	Tooltip,
	Legend,
} from 'recharts';
import theme from '../../styles/theme/theme';

import { formatNumberToUnit } from '../../utils/formatNumbers';

const MetisLineChart = ({ data }) => {
	const formatData = data.finanzing.invest.map(function (v, i) {
		return {
			year: i,
			rent: data.finanzing.rent[i],
			invest: v,
		};
	});
	const contentStyle = {
		backgroundColor: theme.palette.blocks.cardWrapper.background,
	};

	return (
		<ResponsiveContainer width="100%" height={280} minWidth={0}>
			<LineChart
				width={600}
				height={300}
				data={formatData}
				margin={{ top: 10, right: 10, left: 10, bottom: 10 }}
			>
				<YAxis hide />
				<XAxis dataKey="year" interval="preserveStartEnd" hide />
				<Tooltip
					labelFormatter={(t) => `${t} Jahre`}
					formatter={(value) => formatNumberToUnit(value)}
					contentStyle={contentStyle}
				/>
				<Legend height={36} iconSize="25" />
				<Line
					type="linear"
					dataKey="rent"
					unit=" €"
					name="Mietmodell ohne Investition"
					stroke="#EC6622"
					dot={false}
					strokeWidth={3}
				/>
				<Line
					unit=" €"
					type="linear"
					dataKey="invest"
					name="Kaufmodell mit Investition"
					stroke="#c2ccd0"
					dot={false}
					strokeWidth={3}
				/>
				<Line
					tooltipType="none"
					type="monotone"
					dataKey="year"
					name="Jahre"
					stroke="#FFFFFF"
					dot={false}
					strokeWidth={1}
					label={{
						fill: '#FFFFFF',
						fontSize: 16,
						transform: 'translate(0, 23)',
					}}
					legendType="none"
				/>
			</LineChart>
		</ResponsiveContainer>
	);
};

export default MetisLineChart;
